export const PLANOS_BOX = {
  planos: 1,
  pagamento: 2,
  pagamentoCardSuccess: 3,
  pagamentoBoletoSuccess: 4
};

export const CADASTRO_DADOS = {
  email: '',
  senha: '',
  nome: '',
  cpf_cnpj: '',
  data_nascimento: '',
  telefone: '',

  cidade: '',
  uf: '',
  cep: '',
  bairro: '',
  logradouro: '',
  complemento: '',
  numero: '',
  qtd_dias: '',
  tipo_treino: '',
  onde_treina: '',
  tempo_musculacao: '',
  problemas: [],
  problemasAdicionados: [],
  problemasOutros: [],
  plano: '',

  sexo: 'F',

  tipo_pagamento: '',
  nome_cartao: '',
  numero_cartao: '',
  data_expiracao: '',
  cvv: '',

  peso: '',
  altura: ''
};

export const GOOGLE_RECAPTCHA_V2 = '6Lew7acUAAAAAOwzL8TuxEmdm1JC9ynkJbqSSIwa';



// WEBPACK FOOTER //
// ./src/config/Config.js